/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_ClearInputs */

const cs_properties_bulk_clear = /** @type {(inputs: Properties_Bulk_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit výběr`)
};

const en_properties_bulk_clear = /** @type {(inputs: Properties_Bulk_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Properties_Bulk_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_clear = /** @type {((inputs?: Properties_Bulk_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_clear(inputs)
	return cs_properties_bulk_clear(inputs)
});